import { canUseSnatTicketFromPayload } from '@/utils/snatTicketAccess';

export function hasNotebookAccessFromUserPayload(payload) {
  return canUseSnatTicketFromPayload(payload);
}

export async function resolveNotebookAccess(AuthService) {
  try {
    const r = await AuthService.getUserByToken();
    return hasNotebookAccessFromUserPayload(r?.data?.data);
  } catch {
    return false;
  }
}
